export default defineNuxtRouteMiddleware(async () => {
  if (await denies(globalAdmin)) {
    return navigateTo("/404");
  }
});
